(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cz-body-map"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cz-body-map')) {
    class CzBodyMap extends HTMLElement {
      connectedCallback() {
        this.options = Array.from(this.querySelectorAll('[data-option]'));
        this.viewLabel = this.querySelector('[data-view-label]');
        this.options.forEach((option) => option.addEventListener('click', () => this.select(option, true)));
        this.querySelectorAll('[data-set-view]').forEach((btn) =>
          btn.addEventListener('click', () => {
            const target = btn.dataset.setView;
            this.setView(target === 'toggle' ? (this.dataset.view === 'front' ? 'back' : 'front') : target);
          })
        );
        const active = this.querySelector('[data-option].is-active') || this.options[0];
        if (active) this.select(active, false);
      }

      parse(value) {
        return (value || '')
          .split(';')
          .map((pair) => pair.split(',').map((n) => parseFloat(n)))
          .filter((pair) => pair.length === 2 && !isNaN(pair[0]) && !isNaN(pair[1]));
      }

      draw(side, points) {
        const layer = this.querySelector(`[data-points="${side}"]`);
        if (!layer) return;
        layer.innerHTML = '';
        points.forEach(([x, y], index) => {
          const dot = document.createElement('span');
          dot.className = 'cz-map__point';
          dot.style.left = `${x}%`;
          dot.style.top = `${y}%`;
          dot.style.animationDelay = `${index * 40}ms`;
          layer.appendChild(dot);
        });
      }

      setView(view) {
        this.dataset.view = view;
        this.querySelectorAll('[data-set-view]').forEach((btn) =>
          btn.classList.toggle('is-active', btn.dataset.setView === view)
        );
        if (this.viewLabel) this.viewLabel.textContent = this.viewLabel.dataset[view];
      }

      select(option, userAction) {
        this.options.forEach((o) => {
          const on = o === option;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.draw('front', this.parse(option.dataset.front));
        this.draw('back', this.parse(option.dataset.back));
        const front = this.parse(option.dataset.front).length;
        const back = this.parse(option.dataset.back).length;
        let view = option.dataset.view || 'front';
        if (view === 'front' && !front && back) view = 'back';
        if (view === 'back' && !back && front) view = 'front';
        this.setView(view);
        const name = this.querySelector('[data-selected-name]');
        if (name) name.textContent = option.dataset.name;
        const icon = this.querySelector('[data-selected-icon]');
        const tpl = option.querySelector('template[data-icon]');
        if (icon && tpl) icon.innerHTML = tpl.innerHTML;
        this.querySelectorAll('[data-products]').forEach((group) =>
          group.classList.toggle('is-active', group.dataset.products === option.dataset.option)
        );
        if (userAction && window.matchMedia('(max-width: 768px)').matches) {
          option.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }
    customElements.define('cz-body-map', CzBodyMap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cz-gallery')) {
    class CzGallery extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.index = 0;
        this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.thumb))));
        this.querySelectorAll('[data-dir]').forEach((b) =>
          b.addEventListener('click', () => this.go(this.index + Number(b.dataset.dir)))
        );
        let startX = null;
        const main = this.querySelector('.cz-gallery__main');
        main.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        main.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        });
      }

      go(i) {
        const n = this.slides.length;
        if (!n) return;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.index));
        this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === this.index));
        const thumb = this.thumbs[this.index];
        if (thumb) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
    customElements.define('cz-gallery', CzGallery);
  }

  (function () {
    let moneyFormat = '';

    function group(value, decimals, thousands, decimal) {
      const fixed = (value / 100).toFixed(decimals);
      const [whole, fraction] = fixed.split('.');
      const withThousands = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? withThousands + decimal + fraction : withThousands;
    }

    function money(cents) {
      if (!moneyFormat) return group(cents, 2, '.', ',') + ' TL';
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals':
            return group(cents, 0, ',', '.');
          case 'amount_with_comma_separator':
            return group(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return group(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return group(cents, 2, "'", '.');
          default:
            return group(cents, 2, ',', '.');
        }
      });
    }

    function priceHtml(variant, qty) {
      const now = variant.price * qty;
      let html = `<span class="cz-price"><span class="cz-price__now">${money(now)}</span>`;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += `<s class="cz-price__was">${money(variant.compare_at_price * qty)}</s>`;
      }
      return html + '</span>';
    }

    function init(section) {
      if (section.dataset.czReady) return;
      section.dataset.czReady = 'true';
      const formatEl = section.querySelector('[data-money-format]');
      if (formatEl) moneyFormat = JSON.parse(formatEl.textContent);
      const json = section.querySelector('[data-variants]');
      const variants = json ? JSON.parse(json.textContent) : [];
      const input = section.querySelector('[data-variant-input]');
      const fieldsets = Array.from(section.querySelectorAll('[data-option-index]'));
      const atc = section.querySelector('.product-form__submit');
      const atcLabel = section.querySelector('[data-atc-label]');

      function updateBundles(variant) {
        section.querySelectorAll('[data-bundle-price]').forEach((el) => {
          el.innerHTML = priceHtml(variant, Number(el.dataset.qty));
        });
        const sticky = section.querySelector('[data-sticky-price]');
        if (sticky) sticky.innerHTML = priceHtml(variant, 1);
        const main = section.querySelector('[data-price] .cz-price');
        if (main) main.outerHTML = priceHtml(variant, 1);
      }

      function markAvailability() {
        fieldsets.forEach((fs, index) => {
          fs.querySelectorAll('input[type="radio"]').forEach((radio) => {
            const selected = fieldsets.map((f) => (f.querySelector('input:checked') || {}).value);
            selected[index] = radio.value;
            const match = variants.find((v) => v.options.every((o, i) => o === selected[i]));
            radio.closest('.cz-pdp__pill').classList.toggle('is-unavailable', !match || !match.available);
          });
        });
      }

      fieldsets.forEach((fs) =>
        fs.addEventListener('change', () => {
          const selected = fieldsets.map((f) => (f.querySelector('input:checked') || {}).value);
          const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
          fs.querySelector('[data-option-value]').textContent = fs.querySelector('input:checked').value;
          if (!variant) return;
          input.value = variant.id;
          if (atc) {
            atc.disabled = !variant.available;
            atc.setAttribute('aria-disabled', String(!variant.available));
            if (atcLabel) atcLabel.textContent = variant.available ? atc.dataset.add : atc.dataset.soldOut;
          }
          const stock = section.querySelector('[data-stock]');
          if (stock) stock.hidden = true;
          updateBundles(variant);
          markAvailability();
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        })
      );
      markAvailability();

      section.querySelectorAll('.cz-pdp__bundle input').forEach((radio) =>
        radio.addEventListener('change', () => {
          section.querySelectorAll('.cz-pdp__bundle').forEach((b) => b.classList.toggle('is-active', b.contains(radio)));
        })
      );

      const divider = section.querySelector('[data-deals-divider]');
      const detectKaching = () => {
        const widget = section.querySelector('kaching-bundles-block, [class*="kaching-bundles"]:not(.kaching-bundles-deal-block-settings)');
        if (!widget || !widget.offsetHeight) return false;
        section.classList.add('cz-has-kaching');
        if (divider) divider.hidden = false;
        return true;
      };
      if (!detectKaching() && 'MutationObserver' in window) {
        const mo = new MutationObserver(() => detectKaching() && mo.disconnect());
        mo.observe(section, { childList: true, subtree: true });
        setTimeout(() => mo.disconnect(), 15000);
      }

      const sticky = section.querySelector('[data-sticky]');
      if (sticky && atc && 'IntersectionObserver' in window) {
        sticky.hidden = false;
        new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        }).observe(atc);
      }
    }

    function boot() {
      document.querySelectorAll('.cz-pdp').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-orbit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cz-orbit')) {
    class CzOrbit extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.cz-orbit__item'));
        this.details = Array.from(this.querySelectorAll('[data-detail]'));
        this.count = this.querySelector('[data-count]');
        this.stage = this.querySelector('.cz-orbit__stage');
        this.items.forEach((item) => {
          item.addEventListener('click', () => this.select(Number(item.dataset.index)));
          item.addEventListener('mouseenter', () => {
            if (window.matchMedia('(hover: hover) and (min-width: 900px)').matches) this.select(Number(item.dataset.index));
          });
        });
        this.resize = () => {
          if (this.stage) this.stage.style.setProperty('--stage', `${this.stage.clientWidth}px`);
        };
        this.resize();
        if ('ResizeObserver' in window && this.stage) new ResizeObserver(this.resize).observe(this.stage);
      }

      select(index) {
        this.items.forEach((item, i) => {
          item.classList.toggle('is-active', i === index);
          item.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
        this.details.forEach((detail, i) => detail.classList.toggle('is-active', i === index));
        if (this.count) this.count.textContent = String(index + 1).padStart(2, '0');
      }
    }
    customElements.define('cz-orbit', CzOrbit);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-track-order"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tracking-form]').forEach((form) => {
    if (form.dataset.czReady) return;
    form.dataset.czReady = 'true';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const code = form.querySelector('input').value.trim();
      if (!code) return;
      const template = form.dataset.url;
      const url = template.includes('{kod}') ? template.replace('{kod}', encodeURIComponent(code)) : template + encodeURIComponent(code);
      window.open(url, '_blank', 'noopener');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
